module.exports = __webpack_public_path__ + "img/shz.8c17f980.png";